import { navigateI18n } from "../../i18n/navigate.js";

/**
 *
 * @param {string} parameterName
 * @param {string} value
 */
export function applySearchParam(parameterName, value) {
  const url = new URL(window.location.href)
  url.searchParams.set(parameterName, value)
  const destination = url.pathname.toString() + url.search
  navigateI18n(destination, {replace: true})
}
